import React from "react";
import Installation from "../../lib/models/Installation";
import InstallationStatistic from "../../lib/models/InstallationStatistic";
import authentication from "../../lib/AuthenticationManager";
import { navigate } from '@reach/router';
import { Menu, MenuButton, MenuItem, MenuList } from '@reach/menu-button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import Segment from "../../lib/models/Segment";

interface Props {
    segment: Segment;
    installation: Installation;
    statistic?: InstallationStatistic;
    onDelete: () => void;
}

interface State {
    showMore: boolean;
}

export default class InstanceCard extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = { showMore: false };
    }

    public render() {
        const region = this.props.segment.region;

        return <div key={this.props.installation!.id} className='column is-one-third-fullhd is-half-tablet is-half-mobile'>
            <div className="card installation">
                <div className='card-header'>
                    <h4 className='card-header-title is-justify-content-space-between'>
                        <span>{this.props.installation!.name}</span>

                        {this.props.installation!.versionMatch
                            ? <span>{this.props.installation!.versionMatch}</span>
                            : <></>}

                        <span>{this.props.installation!.version}</span>
                        {authentication.isManager &&
                            <Menu>
                                <MenuButton className={`dropdown-trigger no-button is-size-5`}><FontAwesomeIcon className='has-text-grey-dark' icon={faEllipsisH} /></MenuButton>
                                <MenuList className='dropdown-content'>
                                    <MenuItem className='dropdown-item' onSelect={() => navigate(`/installations/segment/${this.props.segment.id}/edit/${this.props.installation!.id}`)}>Edit</MenuItem>
                                    <MenuItem className='dropdown-item' onSelect={() => navigate(`/installations/segment/${this.props.segment.id}/copy/${this.props.installation!.id}`)}>Copy To ...</MenuItem>
                                    <MenuItem className='dropdown-item' onSelect={() => this.props.onDelete()}>Delete</MenuItem>
                                    <MenuItem className='dropdown-item' onSelect={() => window.open(`https://${region}.console.aws.amazon.com/cloudwatch/home?region=${region}#logsV2:log-groups/log-group/${Installation.createKey(this.props.installation.name ?? '')}`, '_blank')}>Visit CloudWatch Group</MenuItem>
                                </MenuList>
                            </Menu>
                        }
                    </h4>
                </div>
                <div className={'card-content ' + (this.props.installation!.versionMatch ? 'differentVersion' : '')}>
                    <p><a href={`https://${this.props.installation!.dns + '.' + this.props.segment.domain}`}>https://{this.props.installation!.dns + '.' + this.props.segment.domain}</a></p>

                    {this.state.showMore
                        ?
                            <div>
                                <p><span>Last Statistic Time</span> {this.props.installation?.lastStatistic?.toString() ?? 'N/A'}</p>

                                <ul>
                                    <li><span>RCAs:</span> {this.props.statistic?.rcaCount ?? 'N/A'}</li>
                                    <li><span>Causes:</span> {this.props.statistic?.causeCount ?? 'N/A'}</li>
                                    <li><span>Users:</span> {this.props.statistic?.usersCount ?? 'N/A'}</li>
                                    <li><span>Active Users 30 Days:</span> {this.props.statistic?.activeUsers30Days ?? 'N/A'}</li>
                                    <li><span>Concurrent Users:</span> {this.props.statistic?.concurrentUsersAvg ?? 'N/A'}</li>
                                    <li>
                                        <span>Packages ({this.props.statistic?.packages?.length ?? 'none'}):</span>
                                        {this.props.statistic?.packages?.map(pinfo => <div>{pinfo.name} {pinfo.version}</div>)}
                                    </li>
                                </ul>

                                <div><button onClick={() => this.setState({ showMore: false })}>Show Less</button></div>
                            </div>
                        : <div><button onClick={() => this.setState({ showMore: true })}>Show More</button></div>}
                </div>
            </div>
        </div>;
    }
}